import { ChevronDown } from 'lucide-react';
import React from 'react';
import { UseFormRegister, FieldError, Path } from 'react-hook-form';

interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps<
  T extends Record<string, unknown>,
> extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name?: Path<T>;
  options: SelectOption[];
  register?: UseFormRegister<T>;
  error?: FieldError;
  placeholder?: string;
}

export function Select<T extends Record<string, unknown>>({
  name,
  options,
  register,
  error,
  placeholder,
  className = '',
  ...props
}: SelectProps<T>) {
  return (
    <div className="relative">
      <select
        id={name}
        className={`w-full appearance-none rounded-md border px-3 py-2 shadow-sm focus:border-brand focus:ring-1 focus:ring-brand focus:outline-none ${error ? 'border-red-500' : 'border-line'} ${className} `}
        {...props}
        {...(name && register
          ? register(name, {
              onChange: props.onChange,
              onBlur: props.onBlur,
            })
          : {
              onChange: props.onChange,
              onBlur: props.onBlur,
            })}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown
        className={`pointer-events-none absolute inset-y-0 top-2 right-2 flex items-center`}
      />
    </div>
  );
}
